import IframeActivity from "./IframeActivity";

export default function FridgeChallenge() {
    return (
        <IframeActivity
            src="/activities/fridge/index.html"
            title="Fridge Challenge"
        />
    );
}